// extracted by mini-css-extract-plugin
var _1 = "ApplicantIdentityWidgetRevealActions-moduleApplicantIdentityWidgetRevealActions__BRLe9";
export { _1 as "ApplicantIdentityWidgetRevealActions" }
